export default __webpack_public_path__ + "static/media/Partial.93cf3119.svg";